import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import { Response } from "@angular/http";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class PaymentService {
  constructor(private _http: HttpClient) {}

  public payForCheckWithGiftCard(ticketID, locationID, paymentData) {
    return this._http
      .post("/api/orders/pay/giftcard", {
        ticketID: ticketID,
        locationID: locationID,
        paymentData: paymentData
      })
      .map((response: Response) => response)
      .catch(this.handleError);
  }

  public payForCheckWithCreditCard(ticketID, locationID, paymentData) {
    return this._http
      .post("/api/orders/pay", {
        ticketID: ticketID,
        locationID: locationID,
        paymentData: paymentData
      })
      .map((response: Response) => response)
      .catch(this.handleError);
  }

  private handleError(error) {
    console.error(error);
    if (error.status == 404) {
      // alert('Please change all references to /confidential/fixture/work.json to /fixture/work.json in the work.service.ts file');
    }
    return Observable.throw(error || "Server error");
  }
}



// WEBPACK FOOTER //
// ./src/app/services/payment/payment.service.ts